export default function ({app, error}) {
  if (!app.$planHasPermission('proposal_view')) {
    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー'
    });
  }
}
